import { Box } from "@mui/material";

export default function HeaderComponent() {
  return (
    <div style={{ position: "relative", width: "100%" }}>
      <Box
        sx={{
          /* styles copied from DevTools */
          padding: "16px",
          backgroundColor: "black",
          display: "flex",
          alignItems: "center",
        }}
      >
        <a
          href="https://supergas-power.co.il"
          style={{ display: "inline-block" }}
        >
          <img
            src="logo-supergas-power.png"
            alt="services"
            width="232 "
            height="34"
          />
        </a>
      </Box>

      {/*<img*/}
      {/*  alt="ספלאש לוגו"*/}
      {/*  loading="lazy"*/}
      {/*  width="110"*/}
      {/*  height="110"*/}
      {/*  decoding="async"*/}
      {/*  data-nimg="1"*/}
      {/*  src="./circle_bg.svg"*/}
      {/*  style={{*/}
      {/*    color: "transparent",*/}
      {/*    opacity: "0.4",*/}
      {/*  }}*/}
      {/*/>*/}
    </div>
  );
}
